import { makeAutoObservable } from 'mobx';

class SidebarStore {
    isOpen = false;

    constructor() {
        makeAutoObservable(this);
    }

    openSidebar() {
        this.isOpen = true;
    }

    closeSidebar() {
        this.isOpen = false;
    }
}

export default new SidebarStore();
